<template>
    <div class="p-20 v-card v-sheet v-sheet--outlined theme--light mt-3">
        <div class="detail mx-0 mt-2">
            <div class="table-scroll">
                <table class="main-table table-list table-bordered table-width align-table">
                    <thead>
                        <tr>
                            <th class="text-center width-50-px" @click="$emit('add-new-member')"><i class="fa-solid fa-plus cursor-pointer"></i></th>
                            <th class="text-center min-width-250-px">社員コード</th>
                            <th class="text-center width-100-px">並順</th>
                            <th class="text-center width-100-px">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="data.groupDetail.members.length > 0">
                            <tr v-for="(item, index) in data.groupDetail.members" :key="item._rowKey || index">
                                <td class="text-start">
                                    <span class="staff-id">{{ index + 1 }}</span>
                                </td>
                                <td>
                                    <div class="item-group input-search-area d-flex">
                                        <ans-input-search
                                            :id="'EmployeeCD' + index"
                                            type="number"
                                            input-class="custom-border width-70-px"
                                            v-model="item.EmployeeCD"
                                            :maxLength="4"
                                            :onChangeInput="(idx, value) => $emit('refer-employee', idx, value, item)"
                                            :is-show-clear="false"
                                            page-search="PopupMST008"
                                            :auto-close="true"
                                            :isReadonly="false"
                                            :data-extra="{ company_cd: user.company_cd }"
                                            :errors="errors"
                                            @onReferValueName="(value) => $emit('get-employee-name', value, item)"
                                        />
                                        <div class="w-100">
                                            <ans-input
                                                input-class="span-input not_set overflow-dot border-none-dm"
                                                v-model="item.EmployeeName"
                                                id="EmployeeName"
                                                is-required
                                                :maxLength="100"
                                                :isDisabled="true"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    {{ !item.LineNo ? index + 1 : item.LineNo }}
                                    <a tabindex="1" href="" @click.prevent="$emit('move-up', index)">
                                        <span v-if="data.groupDetail.members.length !== 1"><i class="fa-solid fa-circle-up"></i></span>
                                    </a>
                                    <a tabindex="1" class="ml-5-px" href="" @click.prevent="$emit('move-down', index)">
                                        <span v-if="data.groupDetail.members.length !== 1"><i class="fa-solid fa-circle-down"></i></span>
                                    </a>
                                </td>
                                <td class="text-center">
                                    <span class="delete" @click="$emit('delete-member', index)"><i class="fa-solid fa-trash"></i></span>
                                </td>
                            </tr>
                        </template>
                        <tr v-else class="msg_no_data">
                            <td colspan="4" class="text-center">該当するデータが存在しません。</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'MemberGroupTable',
    props: {},
    data() {
        return {
            errors: []
        };
    },
    computed: { ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']), ...mapState('MNG_DM_Message_Store', ['data', 'options']) }
};
</script>
